import { useContext } from "react";
import { StateContext } from "../state";

export function useSharedState() {
  const { currentState } = useContext(StateContext.Context);

  return currentState.data[0];
}
